/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { NextRequest } from "next/server";

const SALT_LENGTH = 8;

function createSalt(): Uint8Array {
	const salt = new Uint8Array(SALT_LENGTH);
	for (let i = 0; i < SALT_LENGTH; i += 1) {
		salt[i] = Math.floor(Math.random() * 255);
	}
	return salt;
}

async function createHash(secret: Uint8Array, salt: Uint8Array): Promise<Uint8Array> {
	const data = new Uint8Array(secret.byteLength + salt.byteLength);
	data.set(secret);
	data.set(salt, secret.byteLength);
	const hashBuffer = await crypto.subtle.digest("SHA-1", data);
	return new Uint8Array(hashBuffer);
}

function utoa(input: Uint8Array): string {
	let output = "";
	for (let i = 0; i < input.byteLength; i += 1) {
		output += String.fromCharCode(input[i]);
	}
	return btoa(output);
}

function atou(inputB64: string): Uint8Array {
	let inputStr: string;

	try {
		inputStr = atob(inputB64);
	} catch (error: unknown) {
		if (error instanceof Error && error.name === "InvalidCharacterError") {
			return new Uint8Array();
		}
		throw error;
	}

	const output = new Uint8Array(inputStr.length);
	for (let i = 0; i < inputStr.length; i += 1) output[i] = inputStr.charCodeAt(i);
	return output;
}

export async function createToken(): Promise<string> {
	const secret = atou(process.env.EPIC_CSRF_TOKEN_SECRET as string);
	const salt = createSalt();
	const hash = await createHash(secret, salt);

	const token = new Uint8Array(2 + SALT_LENGTH + hash.byteLength);

	token[0] = 0;

	token[1] = SALT_LENGTH;

	token.set(salt, 2);

	token.set(hash, SALT_LENGTH + 2);

	return utoa(token);
}

export async function verifyToken(request: Request): Promise<boolean> {
	const tokenStr = (request as NextRequest).cookies.get(process.env.EPIC_CSRF_TOKEN_COOKIE_NAME as string)?.value || "";
	const token = atou(tokenStr);
	const secret = atou(process.env.EPIC_CSRF_TOKEN_SECRET as string);

	if (token.byteLength < 22) return false;

	const saltByteLength = token[1];
	const salt = token.subarray(2, 2 + saltByteLength);
	const hash = token.subarray(2 + saltByteLength);

	const hashCheck = await createHash(secret, salt);

	if (hash.byteLength !== hashCheck.byteLength) return false;

	for (let i = 0; i < hash.byteLength; i += 1) {
		if (hash[i] !== hashCheck[i]) return false;
	}

	return true;
}
